module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABHElEQVRoge3XMUrEQBhA4Q+xsba1sRJESw8gFlqIIN5BO0E8hJVg5Qk8gdtsISx4BgUbwVPYLbEINgtxN5OEmeD/YMr8eS8wYYYgCIIgCILsnPcxpKqqlVbf3GLWx6AcAY+oZAxY7/C+KY47GffAWsIz2/hQgDztA47wjp0BXJJoE3CJF2wM5DIod+rN2rSK/gs9LZHPsVZiE68FyCYFHOCrANGkgAvMC5BMCrgpQK5VwOJvdP5X3Vg4xbf8Xzl5D8Au3goQTQ6gPug9FyCbHPDLQwHCnQLgesnAWcrQRYa+0Jxo3tzZAtqcRqfYVx+ni6HtfeATe5gM4JJEyo0MznDfp0guroxoEzdxaOQBsNXHkJwBQRAEQRD8S34AEBaRD/CLqtoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/blf.png
// module id = dYD9
// module chunks = 8